import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Logo from '../../images/jupiter-logo-header.png';
import './navbar.scss';
import { useAuth } from '../admin/AuthContext';

function NavBar() {
    const { isAdmin } = useAuth();
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 24);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        setExpanded(false);
    }, [location.pathname]);

	return (
		<>
    		<Navbar
                expand='lg'
                variant='dark'
                expanded={expanded}
                onToggle={(nextExpanded) => setExpanded(nextExpanded)}
                className={`navbar-dark-custom site-header ${isScrolled ? 'is-scrolled' : ''}`}
            >
      			<Container>
        				<Link to='/' className='brand-link' onClick={() => setExpanded(false)}>
						<img className='brand-mark' src={Logo} alt='Jupiter logo mark' width='96' height='96' />
                        <div className='brand-text'>
                            <div className='brand-lockup'>
                                <span className='brand-title'>AstroDavido</span>
                            </div>
                            <span className='brand-subtitle'>astrophotography</span>
                        </div>
					</Link>
        			<Navbar.Toggle aria-controls='basic-navbar-nav' />
        			<Navbar.Collapse id='basic-navbar-nav'>
          				<Nav className='me-auto site-nav-links' >
            				<Nav.Link as={NavLink} to='/images/' end onClick={() => setExpanded(false)}>Images</Nav.Link>
            				<Nav.Link as={NavLink} to='/blog/' onClick={() => setExpanded(false)}>Blog</Nav.Link>
            				<Nav.Link as={NavLink} to='/about/' end onClick={() => setExpanded(false)}>About</Nav.Link>
					<Nav.Link as={NavLink} to='/press/' end onClick={() => setExpanded(false)}>Press</Nav.Link>
					<Nav.Link as={NavLink} to='/tools/fov-calculator/' end onClick={() => setExpanded(false)}>FOV calculator</Nav.Link>
					<Nav.Link as={NavLink} to='/partners/' end onClick={() => setExpanded(false)}>Partners</Nav.Link>
					<Nav.Link as={NavLink} to='/contact/' end onClick={() => setExpanded(false)}>Contact</Nav.Link>
                    {isAdmin ? <Nav.Link as={NavLink} to='/admin/dashboard' onClick={() => setExpanded(false)}>Admin Dashboard</Nav.Link> : null}
          				</Nav>
        			</Navbar.Collapse>
      			</Container>
    		</Navbar>
		</>
  );
}

export default NavBar;
